/*@flow*/

export default class UIDGenerator {
  counter: number;
  seed: string;
  constructor(seed: string) {
    this.seed = 'tfid-' + seed + '-';
    this.counter = 0;
  }

  next(): string {
    return this.seed + this.counter++;
  }

  reset() {
    this.counter = 0;
  }
}
